var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { forwardRef } from 'react';
import { css } from '@emotion/react';
import styled from '../../styles/styled';
import Button from '../Button';
import { secondaryStyles, tertiaryStyles } from '../Button/Button';
const alignmentMap = {
    left: 'flex-end',
    center: 'center',
    right: 'flex-start',
};
const wrapperStyles = ({ theme, align = 'center', }) => css `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  ${theme.mq.kilo} {
    flex-direction: row-reverse;
    justify-content: ${alignmentMap[align]};
  }
`;
const Wrapper = styled('div')(wrapperStyles);
const secondaryButtonStyles = ({ theme, destructive, }) => css `
  ${theme.mq.kilo} {
    margin-right: ${theme.spacings.mega};
    ${secondaryStyles({ variant: 'secondary', destructive })}
  }
  ${theme.mq.untilKilo} {
    margin-right: 0;
    margin-top: ${theme.spacings.mega};
    ${tertiaryStyles({ variant: 'tertiary', destructive })}
  }
`;
const SecondaryButton = styled(Button)(secondaryButtonStyles);
/**
 * The ButtonGroup component groups and formats two buttons.
 */
export const ButtonGroup = forwardRef((_a, ref) => {
    var { actions } = _a, props = __rest(_a, ["actions"]);
    return (_jsxs(Wrapper, Object.assign({}, props, { ref: ref }, { children: [_jsx(Button, Object.assign({}, actions.primary, { variant: "primary" })), actions.secondary && _jsx(SecondaryButton, Object.assign({}, actions.secondary))] })));
});
ButtonGroup.displayName = 'ButtonGroup';
